import { createAsyncThunk } from '@reduxjs/toolkit';

import type { TribunalFilters } from '@/types/tribunal/tribunalTypes';

import { tribunalService } from './services';

export const listarTribunais = createAsyncThunk(
  'tribunal/listar',
  async (filters: TribunalFilters | undefined, { rejectWithValue }) => {
    try {
      return await tribunalService.listar(filters);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const buscarTribunalPorId = createAsyncThunk(
  'tribunal/buscarPorId',
  async (id: string, { rejectWithValue }) => {
    try {
      return await tribunalService.buscarPorId(id);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const buscarTribunalPorCodigo = createAsyncThunk(
  'tribunal/buscarPorCodigo',
  async (codigo: string, { rejectWithValue }) => {
    try {
      return await tribunalService.buscarPorCodigo(codigo);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const buscarTribunaisPorEstado = createAsyncThunk(
  'tribunal/buscarPorEstado',
  async (estado: string, { rejectWithValue }) => {
    try {
      const tribunais = await tribunalService.buscarPorEstado(estado);
      return { data: tribunais, total: tribunais.length };
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);
